/*
 * Papiro · tema propio. Lo único vivo: el estado abierto/cerrado, el horario y
 * el WhatsApp, que se piden al CRM. Si el CRM no responde, se queda lo escrito
 * en los ajustes del tema y no se rompe nada.
 */
(function () {
  'use strict';
  var bloques = document.querySelectorAll('[data-p-vivo]');
  var crm = '';
  for (var i = 0; i < bloques.length && !crm; i++) crm = (bloques[i].getAttribute('data-crm') || '').replace(/\/$/, '');
  if (!crm) {
    var cualquiera = document.querySelector('[data-crm]');
    crm = cualquiera ? (cualquiera.getAttribute('data-crm') || '').replace(/\/$/, '') : '';
  }
  if (!crm || !window.fetch) return;

  // Nunca se espera al CRM más de 7 segundos: la página ya enseña lo de Ajustes del tema
  function pide(ruta) {
    var opciones = { headers: { Accept: 'application/json' } };
    try { if (window.AbortSignal && AbortSignal.timeout) opciones.signal = AbortSignal.timeout(7000); } catch (e) {}
    return fetch(crm + ruta, opciones)
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  // Abierto o cerrado, y el horario de verdad
  if (bloques.length) {
    pide('/api/public/horario').then(function (d) {
      if (!d || !d.success) {
        // Sin CRM: se queda el horario escrito en Ajustes del tema y el chat solo ofrece WhatsApp
        if (window.papiroSinCrm) window.papiroSinCrm();
        return;
      }
      document.querySelectorAll('[data-p-estado]').forEach(function (el) {
        var t = el.querySelector('[data-p-estado-texto]');
        if (t && d.texto) t.textContent = 'Ahora ' + d.texto;
        el.classList.toggle('p-estado--abierto', !!d.abierto);
        el.hidden = false;
      });
      if (d.resumen) document.querySelectorAll('[data-p-horario]').forEach(function (el) { el.textContent = d.resumen; });
    });
  }

  // El WhatsApp bueno es el del CRM
  if (document.querySelector('[data-p-whatsapp]')) {
    pide('/api/public/whatsapp-number').then(function (d) {
      if (!d || !d.success || !d.wa) return;
      document.querySelectorAll('[data-p-whatsapp]').forEach(function (a) {
        a.setAttribute('href', 'https://wa.me/' + d.wa);
        if (a.hasAttribute('data-p-whatsapp-texto') && d.bonito) a.textContent = d.bonito;
      });
    });
  }
})();
